import { FONTS } from 'utils/constants'

export const TYPOGRAPHY = {
  EXAMPLE: {
    fontFamily: FONTS.EXAMPLE,
    fontStyle: 'normal',
    fontWeight: 900,
    fontDisplay: 'swap',
  },
  PROXIMA_NOVA: {
    fontFamily: FONTS.COMMUTER_SANS,
    fontStyle: 'normal',
    fontWeight: 400,
    fontDisplay: 'swap',
  },
  PROXIMA_NOVA_MEDIUM: {
    fontFamily: FONTS.COMMUTER_SANS,
    fontStyle: 'normal',
    fontWeight: 600,
    fontDisplay: 'swap',
  },
  PROXIMA_NOVA_BOLD: {
    fontFamily: FONTS.COMMUTER_SANS,
    fontStyle: 'normal',
    fontWeight: 700,
    fontDisplay: 'swap',
  },
  AVENIR: {
    fontFamily: FONTS.AVENIR,
    fontStyle: 'normal',
    fontWeight: 800,
    fontDisplay: 'swap',
  },
  OSWALD: {
    fontFamily: FONTS.INTERSTATE,
    fontStyle: 'normal',
    fontWeight: 700,
    fontDisplay: 'swap',
  },
  ROBOTO: {
    fontFamily: FONTS.COMMUTER_SANS,
    fontStyle: 'normal',
    fontWeight: 600,
    fontDisplay: 'swap',
  },
}
